/**
 * UI strings for the art system (art.*): construction stages, lesson intro hero, world maps,
 * cast captions and the dev art-style switch. `vi` must cover every `en` key.
 */
export const en = {
  'art.stage1': 'Shapes',
  'art.stage2': 'Outline',
  'art.stage3': 'Details',
  'art.stage4': 'Erase guides',
  'art.stage5': 'Colour & shade',
  'art.youWillDraw': "Today you'll draw",
  'art.introSteps': '{n} steps · about {m} min',
  'art.introHow': 'Shapes first, then the outline, details and colour.',
  'art.letsDraw': "Let's draw!",
  'art.world.intro': "Juno's desk",
  'art.world.animals': 'Forest & meadow',
  'art.world.nature': 'Four seasons',
  'art.world.characters': 'Toy town',
  'art.world.anime': 'Night city',
  'art.world.cuteObjects': 'Kitchen & bedroom',
  'art.style': 'Art style (live config: artStyle)',
  'art.style.follow': 'Follow live config',
  'art.style.storybook': 'A · Storybook (default)',
  'art.style.sticker': 'B · Sticker pop',
  'art.style.pastel': 'C · Soft pastel',
  'art.avatar.fox': 'Fox',
  'art.avatar.cat': 'Cat',
  'art.avatar.bear': 'Bear',
  'art.avatar.bunny': 'Bunny',
  'art.avatar.mouse': 'Mouse',
  'art.avatar.dog': 'Dog',
  'art.avatar.frog': 'Frog',
  'art.avatar.kid': 'Kid',
};

export const vi: Record<keyof typeof en, string> = {
  'art.stage1': 'Hình cơ bản',
  'art.stage2': 'Nét viền',
  'art.stage3': 'Chi tiết',
  'art.stage4': 'Tẩy nét phụ',
  'art.stage5': 'Tô màu & bóng',
  'art.youWillDraw': 'Hôm nay con sẽ vẽ',
  'art.introSteps': '{n} bước · khoảng {m} phút',
  'art.introHow': 'Vẽ hình khối trước, rồi nét viền, chi tiết và tô màu.',
  'art.letsDraw': 'Vẽ thôi!',
  'art.world.intro': 'Bàn vẽ của cô Juno',
  'art.world.animals': 'Rừng & Đồng cỏ',
  'art.world.nature': 'Bốn mùa',
  'art.world.characters': 'Phố đồ chơi',
  'art.world.anime': 'Thành phố đêm',
  'art.world.cuteObjects': 'Bếp & Phòng ngủ',
  'art.style': 'Phong cách hình (live config: artStyle)',
  'art.style.follow': 'Theo live config',
  'art.style.storybook': 'A · Sách tranh (mặc định)',
  'art.style.sticker': 'B · Sticker rực rỡ',
  'art.style.pastel': 'C · Pastel dễ thương',
  'art.avatar.fox': 'Cáo',
  'art.avatar.cat': 'Mèo',
  'art.avatar.bear': 'Gấu',
  'art.avatar.bunny': 'Thỏ',
  'art.avatar.mouse': 'Chuột',
  'art.avatar.dog': 'Cún',
  'art.avatar.frog': 'Ếch',
  'art.avatar.kid': 'Bạn nhỏ',
};
